import type { Networkish, SupWeb3Address } from "@/types";
import { useMemo } from "react";

import useCheckRefundAddress from "@/hooks/web3/useCheckRefundAddress";
import { useStoredData } from "@/store";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";

export default function useGetRefundAddress(chainId: Networkish | undefined = undefined) {
  const storedData = useStoredData();
  const userAddress = useWeb3UserAddress();
  const { isValid, isLoading } = useCheckRefundAddress(chainId);

  return useMemo(
    () => ({
      address: storedData.txSettings.refundAddress ? (storedData.txSettings.refundAddress as SupWeb3Address) : !isValid ? undefined : userAddress,
      isValid,
      isLoading,
    }),
    [isLoading, isValid, storedData.txSettings.refundAddress, userAddress]
  );
}
